export default {"src":"/au/_next/static/media/loading-100.629d9a29.gif","height":100,"width":100,"blurWidth":0,"blurHeight":0};